window.addEventListener("DOMContentLoaded", function () {
    $(".toast-btn").on("click", function () {
        let toastParent = $("#" + $(this).attr("target"));
        toastParent.show();
        toastParent.find(".toast-box").show();
        setTimeout(function () {
            toastParent.find(".toast-box").fadeOut(800, function () {
                toastParent.hide();
            });
        }, 800);
    });

    const { forEach } = require("lodash");

    document.addEventListener("scroll", function () {
        let navBar = document.querySelector(".navbar");
        if (window.pageYOffset > 70) {
            if (navBar !== null) {
                $(".navbar-brand").hide();
                navBar.classList.add("fixed");
            }
        } else {
            if (navBar !== null) {
                navBar.classList.remove("fixed");
                $(".navbar-brand").show();
            }
        }
    });

    $("#sat-menu .dropdown-toggle").on("click", function () {
        $(this).parent().find(".dropdown-menu").toggle();
    });

    $(".toggel-filter-btn").click(function () {
        let btn = $(this);
        btn.text(btn.attr("aria-expanded") != "true" ? "اغلاق" : "بحث من جديد");
    });

    // owl.call.js
    $("#offers-list,#news-list,#offer-group-list").owlCarousel({
        rtl: true,
        margin: 0,
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        navText: [
            "<i class='fas fa-chevron-right right'></i>",
            "<i class='fas fa-chevron-left left'></i>",
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false,
            },
            768: {
                items: 2,
                margin: 15,
                nav: false,
                dots: false,
            },
            940: {
                items: 3,
                margin: 15,
                nav: false,
                dots: false,
            },
            1200: {
                items: 3,
            },
            1300: {
                items: 3,
            },
        },
    });
    $("#team-list").owlCarousel({
        rtl: true,
        margin: 0,
        loop: true,
        nav: true,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        navText: [
            "<i class='fas fa-chevron-right right'></i>",
            "<i class='fas fa-chevron-left left'></i>",
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false,
            },
            768: {
                items: 2,
                margin: 15,
                nav: false,
                dots: false,
            },
            940: {
                items: 3,
                margin: 15,
                nav: false,
                dots: false,
            },
            1200: {
                items: 3,
            },
            1300: {
                items: 3,
            },
        },
    });
    $("#trusted-list").owlCarousel({
        rtl: true,
        margin: 0,
        loop: true,
        dots: true,

        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        responsive: {
            0: {
                items: 2,
                nav: false,
                dots: false,
            },
            768: {
                items: 3,
                margin: 15,
                nav: false,
                dots: false,
            },
            1200: {
                items: 5,
            },
            1300: {
                items: 6,
            },
        },
    });

    $("#slide-testimonal").owlCarousel({
        rtl: true,
        margin: 0,
        center: true,
        loop: true,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        navText: [
            "<i class='fas fa-chevron-right right'></i>",
            "<i class='fas fa-chevron-left left'></i>",
        ],
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false,
            },
            768: {
                items: 2,
                margin: 15,
                nav: false,
                dots: false,
            },
            1000: {
                items: 3,
            },
        },
    });

    $("#announcement-slider").owlCarousel({
        rtl: true,
        margin: 0,
        loop: true,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false,
            },
            768: {
                items: 1,
                margin: 15,
                nav: false,
                dots: false,
            },
            940: {
                items: 1,
                margin: 15,
                nav: false,
                dots: false,
            },
            1200: {
                items: 1,
            },
        },
    });

    $(".reviews-slider").owlCarousel({
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        navText: [
            "<i class='fas fa-chevron-right right'></i>",
            "<i class='fas fa-chevron-left left'></i>",
        ],
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            1024: {
                items: 3,
            },
            1400: {
                items: 3,
            },
        },
    });

    $(".certificates-slider").owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: false,
        navText: [
            "<i class='fas fa-chevron-right right'></i>",
            "<i class='fas fa-chevron-left left'></i>",
        ],
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 2,
            },
            600: {
                items: 3,
            },
            1024: {
                items: 2,
            },
            1400: {
                items: 3,
            },
        },
    });

    // Open/Close Side Menu
    $(".open-sidemenu").click(function () {
        $(this).find(".sidemenu").toggleClass("open");
    });
    $(".sidemenu-nav").click(function (e) {
        e.stopPropagation();
    });

    //support file
    $(".close-support").click(function () {
        $(this).parents(".support").remove();
    });
    $(".support").addClass("open");

    // $(window).on("scroll", function () {
    //     if ($(window).scrollTop() > 80) {
    //         $(".support").addClass("open");
    //     } else {
    //         $(".support").removeClass("open");
    //     }
    // });

    // custom file
    $(".navbar-toggler").click(function () {
        $(".navbar-collapse").slideToggle(300);
    });

    // $(".datepicker-active-monday").datepicker({
    //     changeMonth: true,
    //     changeYear: true,
    //     yearRange: "1900:2100",
    //     beforeShowDay: function (a) {
    //         var instituteVacations = $(this).data('institute-vacations');
    //         var dateString = $.datepicker.formatDate('yy-mm-dd', a);
    //         var dateAvailable = true;
    //         var today = new Date();

    //         if (instituteVacations && instituteVacations.length > 0) {
    //             instituteVacations.forEach(function (instituteVacation) {
    //                 var vacationFromDate = instituteVacation.from_date;
    //                 var vacationToDate = instituteVacation.to_date;
    //                 if (dateString >= vacationFromDate && dateString <= vacationToDate) {
    //                     dateAvailable = false;
    //                 }
    //             });
    //             if (dateAvailable) {
    //                 if (a > today) {
    //                     return [1 == a.getDay()];
    //                 } else {
    //                     return [false, 'disabled-date'];
    //                 }
    //             } else {
    //                 return [false, 'disabled-date'];
    //             }
    //         } else {
    //             if (a > today) {
    //                 return [1 == a.getDay()];
    //             } else {
    //                 return [false, 'disabled-date'];
    //             }
    //         }
    //     }
    // });

    // $(".datepicker-active-monday").datepicker("option", "dateFormat", "dd-mm-yy");
});
